// components/settings/DangerZone.tsx
import React from "react";
import { AlertTriangle, Trash2, Shield } from "lucide-react";

interface DangerZoneProps {
  onDeleteAccount: () => void;
}

const DangerZone: React.FC<DangerZoneProps> = ({ onDeleteAccount }) => {
  return (
    <div className="bg-white rounded-2xl border border-red-200 shadow-sm overflow-hidden">
      {/* Header */}
      <div className="flex items-center gap-3 p-6 border-b border-red-100 bg-red-50/50">
        <div className="w-10 h-10 rounded-xl bg-red-100 flex items-center justify-center">
          <AlertTriangle className="w-5 h-5 text-red-600" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-red-900">Danger Zone</h2>
          <p className="text-sm text-red-600">
            Irreversible and destructive actions
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 bg-gray-50 rounded-xl border border-gray-200">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-lg bg-red-100 flex items-center justify-center flex-shrink-0">
              <Trash2 className="w-5 h-5 text-red-600" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">Delete Account</h3>
              <p className="text-sm text-gray-500 mt-0.5">
                Permanently delete your account and all associated data. This
                action cannot be undone.
              </p>
            </div>
          </div>
          <button
            onClick={onDeleteAccount}
            className="inline-flex items-center gap-2 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-xl shadow-sm hover:shadow transition-all text-sm whitespace-nowrap"
          >
            <Trash2 className="w-4 h-4" />
            Delete Account
          </button>
        </div>

        {/* Warning Note */}
        <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-xl flex items-start gap-3">
          <Shield className="w-4 h-4 text-amber-600 flex-shrink-0 mt-0.5" />
          <div className="text-xs text-amber-700">
            <p className="font-medium mb-1">Before deleting your account:</p>
            <ul className="space-y-0.5">
              <li>• All pending payments will be forfeited</li>
              <li>
                • Your task history and earnings data will be permanently erased
              </li>
              <li>• You won't be able to recover your account or data</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DangerZone;
